import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const LiveBetterRoot = styled('div', {
    background: '$tertiary-200',
    padding: '$6 $2',

    '& .d-only': {
        display: 'none',
        '@bp2': {
            display: 'block'
        }
    },

    '& .m-only': {
        display: 'block',
        '@bp2': {
            display: 'none'
        }
    }
})

export const LiveBetterContainer = styled('div', {
    textAlign: 'center',
})

export const Header = styled('h2', {
    fontSize: '$h3',
    lineHeight: '$h3',
    letterSpacing: '$h3',
    margin: 'auto',
    marginBottom: '$5',

    '@bp2': {
        fontSize: '$h1',
        lineHeight: '$h1',
        letterSpacing: '$h1',
        maxWidth: '800px',
    }
})

export const FeaturesContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '400px',
    width: '100%',
    margin: 'auto',

    '@bp2': {
        gap: '$4',
        flexDirection: 'row',
        maxWidth: 'none',
    }
})

export const ImageColumn = styled('div', {
    position: 'relative',
    width: '100%',
    aspectRatio: 345/222,
    
    '@bp2': {
        width: '400px',
        height: '459px',
        aspectRatio: 'none',
    }
})

export const CopyColumn = styled('div', {
    textAlign: 'left',
    width: '100%',
    padding: '$5 0 $8',

    '@bp2': {
        width: '400px',
        padding: 0,
    }
})

export const Feature = styled('div', {
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '$1',
    padding: '16px 0',
    borderBottom: '1px solid $accent-black',
    '&:first-child': {
        borderTop: '1px solid $accent-black',
    }
})

export const Label = styled(Text, {

})

export const Description = styled(Text, {

})